type ResolutionPaymentPayload = {
  plan_type: string;
  component_plan_id?: string;
};

/** Fail closed before fetch when a local payment payload violates the
 * resolution component discriminant. The backend remains the canonical
 * allowlist validator; this boundary prevents missing/blank local selections. */
export function assertResolutionComponentPayload(data: ResolutionPaymentPayload): void {
  const component = data.component_plan_id;
  if (data.plan_type === "resolution") {
    if (typeof component !== "string" || !component.trim()) {
      throw new Error("Resolution payment requires a non-empty component_plan_id");
    }
    return;
  }
  if (component !== undefined) {
    throw new Error("component_plan_id is valid only for resolution payments");
  }
}
